<template>
    <div class="footer-text">
        <a class="footer-link" :href="this.path">{{ text }}</a>
    </div>
</template>
<script>
export default {
    name: 'FooterLink',
    props: {
        text: String,
        path: String
    }
}
</script>